import { useEffect, useState } from 'react';
import { Trans } from '@common/i18n/trans';
import { Button } from '@common/ui/buttons/button';
import { useAuth } from '@common/auth/use-auth';
import { useSheetNameAction } from '@app_modules/requests/use-sheet-name-action';
import { useMdFormatAction } from '@app_modules/requests/use-md-format-action';

type ExecuteMdFormatActionActionProps = {
  id: number;
  pindex: number;
  market_rate_date: string;
  investor_code: string;
  sheetNames: any;
  loanProgramTypes: any;
};

export function MdFormatAction({ id, market_rate_date, investor_code, sheetNames, loanProgramTypes }: ExecuteMdFormatActionActionProps) {
  const [sheetNameLength, setSheetNameLength] = useState(0);

  useEffect(() => {
    if (sheetNames) {
      setSheetNameLength(sheetNames.length);
    }
  }, [sheetNames]);

  const executeMdFormatAction = useMdFormatAction(id, market_rate_date, investor_code, sheetNames, loanProgramTypes);

  return (
    <>
      <Button
        size={'xs'}
        variant="flat"
        color="orange"
        type="submit"
        onClick={() => {
          executeMdFormatAction.mutate(
            { id, market_rate_date, investor_code, sheet_names: sheetNames, loan_program_types: loanProgramTypes },
            {
              onSuccess: (response) => {
                // onProcess(response.status, response.total_files, response.uploaded_date, response.file_name);
              },
            }
          );
        }}
        disabled={!sheetNameLength || executeMdFormatAction.isPending || !investor_code}
      >
        <Trans message={`Teach AI`} />
      </Button>
    </>
  );
}